import classNames from "classnames";
import parse from "html-react-parser";
import React from "react";
import SlideDown from "react-slidedown";
import MealImage from "./MealImage";
export default class MealMenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.toggleNutritionals = () => {
            this.setState({
                showNutritionals: !this.state.showNutritionals,
            });
        };
        this.meaurement = (key) => {
            switch (key) {
                case "Calories":
                    return "Kcal";
                case "Sodium":
                    return "mg";
                default:
                    return "g";
            }
        };
        this.state = {
            showNutritionals: false,
        };
    }
    render() {
        const { product, isSelected, selectItem } = this.props;
        const { showNutritionals } = this.state;
        return (React.createElement("div", { className: classNames("shop-item", {
                selected: isSelected,
            }) },
            React.createElement("div", { className: "card" },
                React.createElement("div", { className: "card-body" },
                    React.createElement(MealImage, { images: product.images }),
                    React.createElement("div", { className: "card-title" },
                        React.createElement("h3", null, product.text)),
                    this._renderNutriantsTable(product),
                    React.createElement("div", { className: "row gx-0 align-items-end" },
                        React.createElement("div", { className: "col serving-col align-self-start" },
                            "Serving: ",
                            product.serving_size,
                            "g"),
                        React.createElement("div", { className: "col-auto" },
                            React.createElement("a", { href: "#", className: classNames("btn btn-sm btn-collapse", {
                                    collapsed: showNutritionals,
                                }), onClick: this.toggleNutritionals },
                                "More Info",
                                " "))),
                    React.createElement(SlideDown, { closed: !showNutritionals },
                        React.createElement("div", { className: "nutrition-head" },
                            React.createElement("span", { className: "h5" }, product.text),
                            React.createElement("a", { href: "#", className: classNames("btn btn-close", {
                                    collapsed: showNutritionals,
                                }), onClick: this.toggleNutritionals })),
                        React.createElement("div", { className: "ingredients-text" },
                            React.createElement("strong", null, "Ingredients:"),
                            React.createElement("br", null),
                            product.ingredients_text
                                ? parse(product.ingredients_text)
                                : "N/A",
                            React.createElement("br", null),
                            React.createElement("strong", null, "Allergens:"),
                            React.createElement("br", null),
                            product.allergens_text || "None",
                            React.createElement("br", null)),
                        React.createElement("div", { className: "nutrition-footer" }))),
                React.createElement("div", { className: "card-footer" }, isSelected ? (React.createElement("button", { type: "button", className: "btn btn-accent", onClick: () => selectItem(product) }, "Selected")) : (React.createElement("button", { type: "button", className: "btn btn-cta", onClick: () => selectItem(product) }, "Select Meal"))))));
    }
    _renderNutriantsTable(meal) {
        const { nutriants, serving_size } = meal;
        return (React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { colSpan: 2 }, "Typical values"))),
            React.createElement("tbody", null, Object.keys(nutriants)
                .sort()
                .map((key, idx) => (React.createElement("tr", { key: idx },
                React.createElement("td", null, key),
                React.createElement("td", null,
                    nutriants[key],
                    this.meaurement(key))))))));
    }
}
